// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: "/auth",
  DASHBOARD: "/dashboard",
  USER: "/users",
  RESTAURANT: "/restaurants",
  BOOKING: '/bookings',
  REVENUE: '/revenue',
  SURVEY: '/survey',
  CHANGE_PASSWORD: "change-password",
  SUBSCRIPTION: "/subscriptions",
  APP_VERSION: "/app-versions",
};

// ----------------------------------------------------------------------

export const paths = {
  auth: {
    jwt: {
      signIn: `login`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    user: ROOTS.USER,
    restaurants: ROOTS.RESTAURANT,
    booking: ROOTS.BOOKING,
    revenue: ROOTS.REVENUE,
    survey: ROOTS.SURVEY,
    changePassword: ROOTS.CHANGE_PASSWORD,
    subscription: ROOTS.SUBSCRIPTION,
    appVersion: ROOTS.APP_VERSION,
  },
};
